import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@frontend/shadcn/components/ui/alert-dialog';
import { AlertTriangle } from 'lucide-react';
import React from 'react';

interface AlertPFARejectProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  totalMembers: number;
  onConfirm: () => void;
}

export default function AlertPFAReject({
  isOpen,
  onOpenChange,
  totalMembers,
  onConfirm,
}: AlertPFARejectProps): JSX.Element {
  const handleConfirm = () => {
    onConfirm();
    onOpenChange(false);
  };

  return (
    <AlertDialog open={isOpen} onOpenChange={onOpenChange}>
      <AlertDialogContent className="max-w-lg w-[512px] p-6 rounded-2xl">
        <AlertDialogHeader className="flex flex-col items-start gap-2">
          <div className="flex items-center gap-3 w-full">
            <AlertTriangle className="text-red-4 text-xl flex-shrink-0" />
            <AlertDialogTitle className="font-medium text-[16px] leading-[28px] tracking-[0px] text-grey-6">
              Reject order requests for {totalMembers} members
            </AlertDialogTitle>
          </div>
          <AlertDialogDescription className="pl-7 text-[14px] leading-[24px] tracking-[0px] text-grey-5 font-regular-100-paragraph">
            Are you sure you want to reject order requests for {totalMembers} members? This action cannot be undone. These members will be prompted to submit a new order request.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="flex justify-end gap-2 mt-6">
          <AlertDialogCancel className="h-8 px-3 py-1 bg-grey-0 text-grey-6 border-grey-2 rounded-lg text-[14px] font-medium leading-[24px]">
            Cancel
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={handleConfirm}
            className="h-8 px-3 py-1 bg-red-4 text-grey-0 rounded-lg text-[14px] font-medium leading-[24px]"
          >
            Reject
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
